export default "__VITE_ASSET__BnfcaJ3B__"